// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageFeed_root__e8V4y","imagesColumn":"ImageFeed_imagesColumn__DB7MX","imageWrapper":"ImageFeed_imageWrapper__1llmu","evenImageWrapper":"ImageFeed_evenImageWrapper__1_QPW"};